import { ReactionCodeValue } from './constants';
export const defaultReactionsInMenu = [
    'surprised',
    'sad',
    'lol',
    'angry',
];
export const defaultMainReactionName = 'heart';
export const mainReactionCode = ReactionCodeValue.LIKE;
export const resolveMainReactionName = (reactionName) => {
    return reactionName !== null && reactionName !== void 0 ? reactionName : defaultMainReactionName;
};
//# sourceMappingURL=default-reactions.js.map